import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';
import { ResourceType } from '../common/typings';

import { changeValue, closeModal, uploadByLink, UploadByLinkModalAction } from './actions';
import { UploadByLinkModal, UploadByLinkModalProps } from './UploadByLinkModal';

export type StateProps = TStateProps<UploadByLinkModalProps>;

export type DispatchProps = TDispatchProps<UploadByLinkModalProps>;

export const mapStateToProps = (state: State): StateProps => {
    return state.canvasEditor.canvas.uploadByLinkModal;
};

const mapDispatchToProps = (dispatch: Dispatch<UploadByLinkModalAction>): DispatchProps => {
    return {
        onClose: (): void => {
            dispatch(closeModal());
        },
        onChange: (value: string): void => {
            dispatch(changeValue(value));
        },
        onSave: (editorId: string, url: string, urlType: ResourceType): void => {
            dispatch(uploadByLink(editorId, url, urlType));
        }
    };
};

export const UploadByLinkModalContainer = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(UploadByLinkModal);
